import { Component, EventEmitter, inject, input, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IHotlineAvailabilityResult } from 'src/models/app.model';
import packageInfo from 'package.json';
import { DeviceService } from 'src/services/device.service';
@Component({
  selector: 'liberro-basic-layout-footer',
  standalone: false,
  templateUrl: './basic-layout-footer.component.html',
  styleUrl: './basic-layout-footer.component.less'
})
export class BasicLayoutFooterComponent {

  private translateService = inject(TranslateService);
  public deviceService = inject(DeviceService);

  @Input() public showFooterLinks = false;
  @Input() public links: { android: string; ios: string; facebook: string; linkedin: string; } = { android: '', ios: '', facebook: '', linkedin: '' };
  @Input() public variant: 'default' | 'mobile-hamburger' = 'default';
  @Output() public showCookieSettings = new EventEmitter<void>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public appVersion = ((window as any).appVersion = packageInfo.version);

  public hotlineAvailability = input.required<IHotlineAvailabilityResult | null>();

  public get copyrightText(): string {
    const currentYear = new Date().getFullYear();
    return `© ${currentYear} ${this.translateService.instant('footer.copyright')}`;
  }

  public triggerShowCookieSettings(): void {
    this.showCookieSettings.emit();
  }

}
